import { Box } from "@mui/material";
import { Heading, Paragraph } from "@nn-design-system/react-component-library";
import { useSelector } from "react-redux";
import { StoreType } from "../../redux/store/store";
import StelaPersonSelectionField from "../../Components/StelaPersonSelectionField";

const StelaPersonSelectionPage = () => {
   const { proposalNumber, insuredPersons } = useSelector(
      (state: StoreType) => state.authState.stelaContext
   );

   return (
      <Box sx={{ width: "80%", maxWidth: "35rem", margin: "3rem auto" }}>
         <Heading hasMargin={false} mb="1rem" variant="Large">
            Vyberte pojištěnou osobu
         </Heading>
         <Paragraph mb="2rem">Číslo návrhu: {proposalNumber}</Paragraph>
         <StelaPersonSelectionField insuredPersons={insuredPersons} />
      </Box>
   );
};

export default StelaPersonSelectionPage;
